// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"6f440e82","99":"703f03ad","130":"dcdbe9a2","355":"1f1f7083","431":"6424f7f7","637":"e4ebca47","653":"0fa10f6f"}[chunkId] + ".chunk.css";
};